import React from "react";
import {SelectV2, SelectV4, Settings, Switch} from "@housebets/housebets-x-package";

import {currencyOptions, oddsOptions} from "app/mock";
import {usePreferencePanelData} from "./hooks/usePreferencePanelData";
import {FormattedMessage, useIntl} from "react-intl";

export const PreferencePanel: React.FC = (props) => {
    const {isFiat, onFiatChange, emailMarketing, onEmailMarketingChange, hideZeroBalance, onHideZeroBalanceChange} = usePreferencePanelData();
    const {$t} = useIntl();

    return (
        <div {...props}>
            <Settings.PreferencesPanel.PRPanel>
                <Settings.PreferencesPanel.PPanelInner>
                    <Settings.PreferencesPanel.PRRow>
                        <Settings.PreferencesPanel.PRTitle>
                            <FormattedMessage id="PreferencePanel.title" />
                        </Settings.PreferencesPanel.PRTitle>
                    </Settings.PreferencesPanel.PRRow>
                    <Settings.PreferencesPanel.PRRow className="preference-row">
                        <Settings.PreferencesPanel.PCol>
                            <Switch
                                label={
                                    <Settings.PreferencesPanel.Info>
                                        <Settings.PreferencesPanel.InfoTitle>
                                            <FormattedMessage id="PreferencePanel.viewInFiat.title" />
                                        </Settings.PreferencesPanel.InfoTitle>
                                        <Settings.PreferencesPanel.InfoSubtitle>
                                            <FormattedMessage id="PreferencePanel.viewInFiat.subtitle" />
                                        </Settings.PreferencesPanel.InfoSubtitle>
                                    </Settings.PreferencesPanel.Info>
                                }
                                isFullWidth
                                size="large-2"
                                isChecked={isFiat}
                                onCheck={onFiatChange}
                                theme="grey-2"
                            />
                        </Settings.PreferencesPanel.PCol>
                        <Settings.PreferencesPanel.PCol>
                            <SelectV4 options={currencyOptions} selectedIds={["1"]} onSelect={() => {}} />
                        </Settings.PreferencesPanel.PCol>
                    </Settings.PreferencesPanel.PRRow>
                    {/* TODO: not in use now */}
                    <Settings.PreferencesPanel.PRRow>
                        <Settings.PreferencesPanel.PCol>
                            <Settings.PreferencesPanel.Info>
                                <Settings.PreferencesPanel.InfoTitle>
                                    <FormattedMessage id="PreferencePanel.oddsPreference.title" />
                                </Settings.PreferencesPanel.InfoTitle>
                                <Settings.PreferencesPanel.InfoSubtitle>
                                    <FormattedMessage id="PreferencePanel.oddsPreference.subtitle" />
                                </Settings.PreferencesPanel.InfoSubtitle>
                            </Settings.PreferencesPanel.Info>
                        </Settings.PreferencesPanel.PCol>
                        <Settings.PreferencesPanel.PCol>
                            <SelectV2
                                searchPlaceholder={$t({id: "SearchCurrencies"})}
                                options={oddsOptions}
                                onSelect={() => {}}
                                selectedIds={["1"]}
                                thumbLabel=""
                            />
                        </Settings.PreferencesPanel.PCol>
                    </Settings.PreferencesPanel.PRRow>
                    {/* TODO: not in use now */}
                    {/* <Settings.PreferencesPanel.PRRow>
                        <Settings.PreferencesPanel.PCol>
                            <Switch
                                label={
                                    <Settings.PreferencesPanel.Info>
                                        <Settings.PreferencesPanel.InfoTitle>
                                            Private Mode
                                        </Settings.PreferencesPanel.InfoTitle>
                                        <Settings.PreferencesPanel.InfoSubtitle>
                                            Other users won&#39;t be able to view your wins, losses and
                                            wagered statistics
                                        </Settings.PreferencesPanel.InfoSubtitle>
                                    </Settings.PreferencesPanel.Info>
                                }
                                isFullWidth
                                size="large-2"
                                isChecked={false}
                                onCheck={() => { }}
                                theme="grey-2"
                            />
                        </Settings.PreferencesPanel.PCol>
                    </Settings.PreferencesPanel.PRRow> */}
                    <Settings.PreferencesPanel.PRRow>
                        <Settings.PreferencesPanel.PCol>
                            <Switch
                                label={
                                    <Settings.PreferencesPanel.Info>
                                        <Settings.PreferencesPanel.InfoTitle>
                                            <FormattedMessage id="PreferencePanel.emailMarketing.title" />
                                        </Settings.PreferencesPanel.InfoTitle>
                                        <Settings.PreferencesPanel.InfoSubtitle>
                                            <FormattedMessage id="PreferencePanel.emailMarketing.subtitle" />
                                        </Settings.PreferencesPanel.InfoSubtitle>
                                    </Settings.PreferencesPanel.Info>
                                }
                                isFullWidth
                                size="large-2"
                                isChecked={emailMarketing}
                                onCheck={onEmailMarketingChange}
                                theme="grey-2"
                            />
                        </Settings.PreferencesPanel.PCol>
                    </Settings.PreferencesPanel.PRRow>
                    <Settings.PreferencesPanel.PRRow>
                        <Settings.PreferencesPanel.PCol>
                            <Switch
                                label={
                                    <Settings.PreferencesPanel.Info>
                                        <Settings.PreferencesPanel.InfoTitle>
                                            <FormattedMessage id="PreferencePanel.hideZeroBalances.title" />
                                        </Settings.PreferencesPanel.InfoTitle>
                                        <Settings.PreferencesPanel.InfoSubtitle>
                                            <FormattedMessage id="PreferencePanel.hideZeroBalances.subtitle" />
                                        </Settings.PreferencesPanel.InfoSubtitle>
                                    </Settings.PreferencesPanel.Info>
                                }
                                isFullWidth
                                size="large-2"
                                isChecked={hideZeroBalance}
                                onCheck={onHideZeroBalanceChange}
                                theme="grey-2"
                            />
                        </Settings.PreferencesPanel.PCol>
                    </Settings.PreferencesPanel.PRRow>
                </Settings.PreferencesPanel.PPanelInner>
            </Settings.PreferencesPanel.PRPanel>
        </div>
    );
};

PreferencePanel.displayName = "PreferencePanel";
